export default {
    private: false,
    slug: 'berri-fit',
    promo: 'Berri Fit recorded a healthy 4x Lift in Engagement with authentic video content.',
    meta: {
        title: 'Berri Fit X Foap  - Case study',
        description: 'Learn how FOAP and Facebook helped Berri Fit reach an impressive ROAS',
        ogImage: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logoHref: 'https://berrifit.com',
        logo: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-logo.png')
    },
    challenge: {
        visible: true,
        title: 'Walk the talk',
        subtitle: 'Santa Monica based Berri Fit began with a simple message: when you eat better, you feel better. They set out to test this maxim in a sports drink market where the health credentials marketed don’t always stack up to the actual ingredients supplied. No synthetics, additives or chemicals in Berri Fit’s plant-based beverages. Just 100% organic goodness for children and athletes alike.',
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock.png'),
            poster: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-berri-fit-2.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-berri-fit-2.mp4',
                type: 'video/mp4'
            }]
        },
        footer: 'The health-sports drink producer recorded a healthy 4x lift in engagement and 298% improvement in Ad Recall Lift with a Foap-directed video ad campaign on Facebook, while also reducing their CPM by almost a half.',
        float01: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
        ogImage: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-og.jpg')
    },
    solutionv2: {
        visible: true,
        title: 'Shaking up the market',
        subtitle: `
            Berri Fit wanted to snatch some shelf space from the big labels in the mainstream retail outlets 
            by promoting their product in local CVS stores. They decided to try out video ads with authentic, 
            localised content to speak directly to everyday athletes and health-conscious parents, and increase brand awareness in the process. 
        `,
        photo0: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-00.jpg'),
    },
    solutionv22: {
        visible: true,
        title: 'Juicing it up with video',
        subtitle: `
            Berri Fit prides itself on providing an authentic, organic alternative to the other less-than healthy sports drinks on the market. 
            It makes sense then that they would want to promote their product with authentic visual content featuring real people –  and not just airbrushed models. 
            <br /><br />
            In the past, they had seen a lot of success by transferring this philosophy into static Facebook Carousel Ads. In this particular campaign, 
            they had a specific goal. They wanted to announce their arrival in local CVS stores – and the louder, the better. 
            <br /><br />
            They felt that only the richness of video could deliver this statement. And to push people local, they knew that they had to present a local image, 
            one that their buyer persona (healthwise sports-enthusiasts and parents) could relate and engage with. 
            <br /><br />
            Foap, the crowdsourced content platform, seemed like the obvious marketing partner with a community of 3 million creatives delivering authentic and 
            engaging videos, all tailored to a specific campaign brief. With seven years in the game and as an official Facebook Marketing Partner, Berri Fit also 
            knew that the Foap creative team would be able to expertly curate their campaign and deliver results.
            <br /><br />
            Their dedicated Foap curator suggested a Sampling Video Mission to promote accuracy and cost-effectiveness. What did this mean? Only the most suited 
            videographers with the richest video were hand-picked for consideration.
            <br /><br />
            A winning video ad was selected and optimised for Facebook with geo and interest targeting. And presto, the asset was quickly uploaded to Facebook 
            via Foap’s content migration console. 
            <br /><br />
            But the journey didn’t end there. Foap supplied post-production support to ensure that the campaign progressed without any hiccups.  
     
        `,
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo1: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-03.jpg'),
    },
    resultsv2: {
        visible: true,
        title: 'Organic always pays',
        textBlock: `
            Berri Fit’s Facebook campaign was not just a win for video ads but their company’s philosophy. 
            If you want engagement, then you’d better make it authentic and organic. Their campaign delivered:  
        `,
        testimony: {
            title: 'Client testimony:',
            content: `
                “For a small company in the middle of an expansion phase, it was a real pleasure to have Foap quarterback this campaign all the way through, 
                from content creation to legals to Facebook optimization, especially when we were trying out video ads for the first time. I’d say ‘priceless’, 
                but that wouldn’t exactly be true. We nearly halved our CPM”
                <br /><br />
                Jerome Tse, CEO and Founder of Berri Fit
            `,
        },
        list: [{
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            title: '4x',
            subtitle: 'higher engagement rate'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '-40%',
            subtitle: 'lower CPM than other engagement campaigns'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-globe.svg'),
            title: '298%',
            subtitle: 'improvement in Ad Recall Lift than other campaigns'
        }],
        photo2: require('Theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-results-photo-01.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/berriFit.js